module.exports = __webpack_public_path__ + "static/media/popcorn-ufo.5f4d6db0.png";